import CalendarIcon from "@mui/icons-material/CalendarTodayRounded";
import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInboxRounded";
import LanguageIcon from "@mui/icons-material/LanguageRounded";
import RevertIcon from "@mui/icons-material/ReplayRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { RequestSubmissionInfo } from "../../../../../api/types/dataCollectionTypes";
import UnpublishIcon from "@entrilia/shared/icons/UnpublishIcon";
import DataRequestPageContext from "./DataRequestPageContext";

export const ActionsCell = ({ row }: { row: RequestSubmissionInfo }) => {
  const {
    hasPermissionsToManage,
    onPublishSubmissions,
    onUnpublishSubmissions,
    onSendSubmissionReminders,
    onRequestChangesForSubmissions,
    onDeleteSubmissions,
    onChangeSubmissionsDueDate,
  } = useDefinedContext(DataRequestPageContext);

  if (!hasPermissionsToManage) {
    return null;
  }

  if (row.status === "Draft") {
    return (
      <ActionsMenuButton
        items={[
          {
            label: "Publish",
            icon: <LanguageIcon />,
            onClick: () => onPublishSubmissions([row]),
          },
          {
            label: "Change Due Date",
            icon: <CalendarIcon />,
            onClick: () => onChangeSubmissionsDueDate([row]),
          },
          {
            label: "Delete",
            icon: <DeleteIcon color="error" />,
            onClick: () => onDeleteSubmissions([row]),
          },
        ]}
      />
    );
  }

  if (row.status === "Pending") {
    return (
      <ActionsMenuButton
        items={[
          {
            label: "Send Reminders",
            icon: <ForwardToInboxIcon />,
            onClick: () => onSendSubmissionReminders([row]),
          },
          {
            label: "Change Due Date",
            icon: <CalendarIcon />,
            onClick: () => onChangeSubmissionsDueDate([row]),
          },
          {
            label: "Unpublish",
            icon: <UnpublishIcon />,
            onClick: () => onUnpublishSubmissions([row]),
          },
        ]}
      />
    );
  }

  if (row.status === "Scheduled") {
    return (
      <ActionsMenuButton
        items={[
          {
            label: "Change Due Date",
            icon: <CalendarIcon />,
            onClick: () => onChangeSubmissionsDueDate([row]),
          },
        ]}
      />
    );
  }

  if (row.status === "Completed") {
    return (
      <ActionsMenuButton
        items={[
          {
            label: "Request Changes",
            icon: <RevertIcon color="warning" />,
            onClick: () => onRequestChangesForSubmissions([row]),
          },
        ]}
      />
    );
  }

  return null;
};
